// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#909090","menuActiveText":"#4F79FD","subMenuActiveText":"#4F79FD","menuBg":"#fff","menuHover":"#fff","subMenuBg":"#fff","subMenuHover":"#fff","sideBarWidth":"262px"};